import { render, staticRenderFns } from "./ChatbotDialog.vue?vue&type=template&id=9ae47614&scoped=true"
import script from "./ChatbotDialog.vue?vue&type=script&lang=ts"
export * from "./ChatbotDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae47614",
  null
  
)

export default component.exports